document.querySelectorAll('.product--merch').forEach(section => {

    const product = JSON.parse(section.querySelector('.productJSON').textContent);
    let activeVariant = JSON.parse(section.querySelector('.activeVariantJSON').textContent);

    if (Shopify.theme.role === 'development') {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Swiper
     ************/

    let swiperExists = false;
    let productSwiper;

    if (!section.querySelector('.productVisualSingle')) {
        swiperExists = true;

        productSwiper = new Swiper(section.querySelector('.productVisualSwiper'), {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            on: {
                slideChange() {
                    section.querySelectorAll('.productVisualSwiperSlide video').forEach(v => v.pause());
                }
            }
        });

        section.querySelectorAll('.productVisualSwiperSlide').forEach(slide => {
            slide.addEventListener('click', function () {
                const video = this.querySelector('video');
                if (!video) return;
                this.querySelector('.productVisualSwiperSlidePlay')?.remove();
                video.controls = true;
                video.play();
            });
        });

        section.querySelectorAll('.productVisualThumbsSlide').forEach(thumb => {
            thumb.addEventListener('click', function () {
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });
    }

    /***************
     Update product
     ***************/

    section.querySelectorAll('input, select').forEach(el => {
        el.addEventListener('change', function () {
            if (el.classList.contains('imageSwap')) {
                section.querySelector('.productVisualSingle.active')?.classList.remove('active');
                section.querySelector(`.productVisualSingle[data-value="${el.value}"]`)?.classList.add('active');
            }
            updateProduct().catch(e => console.error(e));
        });
    });

    async function updateProduct() {
        if (product.variants.length === 1) {
            activeVariant = product.variants[0];
        } else {
            const options = [];
            section.querySelectorAll('.productOptionsValues').forEach(group => {
                const checked = group.querySelector('input:checked');
                if (checked) options.push(checked.value);
            });
            activeVariant = product.variants.find(v => JSON.stringify(v.options) === JSON.stringify(options));
        }

        if (!activeVariant) {
            section.querySelector('.productATC').disabled = true;
            section.querySelector('.productATCText').textContent = 'Not Available';
            return;
        }

        // Swiper — jump to variant image
        if (activeVariant.featured_image && swiperExists) {
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        // Price
        const compareEl = section.querySelector('.productPriceCompare');
        const realEl = section.querySelector('.productPriceReal');
        compareEl.textContent = activeVariant.compare_at_price > activeVariant.price
            ? price(activeVariant.compare_at_price)
            : '';
        realEl.textContent = price(activeVariant.price);

        // ATC state
        if (activeVariant.available) {
            section.querySelector('.productATC').disabled = false;
            section.querySelector('.productATCText').textContent = 'Add To Cart';
        } else {
            section.querySelector('.productATC').disabled = true;
            section.querySelector('.productATCText').textContent = 'Sold Out';
        }

        // Persist selected variant in URL
        const url = new URL(window.location.href);
        url.searchParams.set('variant', activeVariant.id);
        window.history.replaceState({}, '', url);
    }

    updateProduct().catch(e => console.error(e));

    /***********
     Quantity
     ***********/

    const qtyInput = section.querySelector('.productQty');

    section.querySelector('.productQtyMinus')?.addEventListener('click', () => {
        const val = parseInt(qtyInput.value);
        if (val > 1) qtyInput.value = val - 1;
    });

    section.querySelector('.productQtyPlus')?.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value) + 1;
    });

    /******
     ATC
     ******/

    section.querySelector('.productATC').addEventListener('click', async () => {
        section.querySelector('.productATC').classList.add('loading');

        await addProduct({
            items: [{
                quantity: parseInt(qtyInput.value),
                id: activeVariant.id,
            }]
        });

        section.querySelector('.productATC').classList.remove('loading');
        await openCart();
    });

});
